import { NextPage } from 'next';
import MultistreamingPage from '@sy/app-client/src/ssrAdapter/pages/MultistreamingPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const Multistreaming: NextPage<InferProps<typeof getServerSideProps>> = ({
	navigation,
	user,
}) => (
	<MarketingTemplate
		activePage="/multistreaming"
		navigation={navigation}
		user={user}
	>
		<MultistreamingPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.multistreaming'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: ['common', 'auth', 'landing', 'landingMultistreaming'],
});

export default Multistreaming;
